<template>
  <div class="page-column">
    <Header :type="true"/>
    <Agency />
    <Footer />
  </div>
</template>

<script>
import Header from '../layout/Header.vue'
import Agency from '../../components/center/Agency.vue'
import Footer from '../layout/Footer.vue'
export default {
  components: {
    Header,
    Agency,
    Footer
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/center/Agency.vue